<div class="w-full rounded-2xl bg-white p-5 shadow-xl sm:p-6">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">Edit contact</h2>
      <p class="mt-1 text-sm text-slate-500">
        Update this person’s details.
      </p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  <div class="mt-5 flex flex-col gap-4">
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <lib-signal-text-field
        label="First name"
        placeholder="e.g. John"
        [value]="firstName()"
        [debounceValueChange]="false"
        (valueChange)="firstName.set($event)" />

      <lib-signal-text-field
        label="Last name"
        placeholder="e.g. Bravo"
        [value]="lastName()"
        [debounceValueChange]="false"
        (valueChange)="lastName.set($event)" />
    </div>

    <lib-signal-text-field
      label="Email"
      placeholder="e.g. john@example.com"
      [value]="email()"
      [debounceValueChange]="false"
      (valueChange)="email.set($event)" />

    <lib-signal-dropdown
      label="Status"
      [items]="statusOptions"
      valuePath="value"
      displayPath="label"
      [value]="status()"
      [debounceValueChange]="false"
      (valueChange)="onStatusChange($event)" />

    <div class="mt-2 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
      <lib-signal-button
        appearance="outline"
        [disabled]="patchState.loading()"
        (clicked)="close()">
        Cancel
      </lib-signal-button>
      <lib-signal-button
        [loading]="patchState.loading()"
        [disabled]="patchState.loading()"
        (clicked)="onSave()">
        Save
      </lib-signal-button>
    </div>
  </div>
</div>
